export default "__VITE_ASSET__4obd8d8Z__"